<div class="todo-workspace">
  <div class="page-header">
    <div>
      <p class="eyebrow">Work Queue</p>
      <h2>My Todo</h2>
      <p class="subtitle">Assigned project tasks and private todos in one standalone workspace.</p>
    </div>
    <div class="header-actions">
      <button mat-flat-button color="primary" (click)="openCreateTodo()" [disabled]="creating">
        {{ creating ? 'Opening...' : 'Add Todo' }}
      </button>
      <button mat-stroked-button (click)="load()">Refresh</button>
    </div>
  </div>

  <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>

  <mat-tab-group>
    <mat-tab label="Assigned Tasks">
      <section class="table-card">
        <div class="toolbar">
          <mat-form-field appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select [(ngModel)]="taskStatus" (selectionChange)="load()">
              <mat-option value="all">All</mat-option>
              <mat-option value="Pending">Pending</mat-option>
              <mat-option value="In Progress">In Progress</mat-option>
              <mat-option value="Blocked">Blocked</mat-option>
              <mat-option value="Done">Done</mat-option>
              <mat-option value="Completed">Completed</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="table-wrap" *ngIf="tasks.length; else emptyTasks">
          <table class="todo-table">
            <thead>
              <tr>
                <th>Task</th>
                <th>Project</th>
                <th>Status</th>
                <th>Priority</th>
                <th>Due</th>
                <th>Comments</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of tasks">
                <td>
                  <strong>{{ row.title }}</strong>
                  <small>{{ row.description || 'No description' }}</small>
                </td>
                <td>{{ row.projectName || '-' }}</td>
                <td><span class="status-pill">{{ row.status }}</span></td>
                <td>{{ row.priority || '-' }}</td>
                <td>{{ row.dueDate ? (row.dueDate | date:'mediumDate') : '-' }}</td>
                <td>{{ row.commentCount || 0 }}</td>
                <td><button mat-stroked-button color="primary" (click)="openTask(row)">View</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </mat-tab>

    <mat-tab label="My Todos">
      <section class="table-card">
        <div class="toolbar">
          <mat-form-field appearance="outline">
            <mat-label>Status</mat-label>
            <mat-select [(ngModel)]="todoStatus" (selectionChange)="load()">
              <mat-option value="all">All</mat-option>
              <mat-option value="Pending">Pending</mat-option>
              <mat-option value="In Progress">In Progress</mat-option>
              <mat-option value="Blocked">Blocked</mat-option>
              <mat-option value="Done">Done</mat-option>
              <mat-option value="Completed">Completed</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="table-wrap" *ngIf="todos.length; else emptyTodos">
          <table class="todo-table">
            <thead>
              <tr>
                <th>Todo</th>
                <th>Status</th>
                <th>Priority</th>
                <th>Due</th>
                <th>Comments</th>
                <th>Updated</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of todos">
                <td>
                  <strong>{{ row.title }}</strong>
                  <small>{{ row.description || 'No description' }}</small>
                </td>
                <td><span class="status-pill">{{ row.status }}</span></td>
                <td>{{ row.priority || '-' }}</td>
                <td>{{ row.dueDate ? (row.dueDate | date:'mediumDate') : '-' }}</td>
                <td>{{ row.commentCount || 0 }}</td>
                <td>{{ row.updatedAt | date:'short' }}</td>
                <td><button mat-stroked-button color="primary" (click)="openTodo(row)">View</button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
    </mat-tab>
  </mat-tab-group>
</div>

<ng-template #emptyTasks>
  <div class="empty-state">No assigned tasks found for this filter.</div>
</ng-template>

<ng-template #emptyTodos>
  <div class="empty-state">No personal todos yet. Add one above.</div>
</ng-template>
